import {Component, inject, OnInit, signal} from '@angular/core';
import {AccessService} from '../../services/access';
import {DataService} from '../../services/data';
import {PaginationComponent} from 'ngx-bootstrap/pagination';
import {FormsModule} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-admin',
    imports: [
        PaginationComponent,
        FormsModule,
        DatePipe,
    ],
  templateUrl: './admin.html',
  styleUrl: './admin.css',
})
export class Admin implements OnInit {

    private dataService = inject(DataService);
    private accessService = inject(AccessService);
    private router = inject(Router);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1,
    };

    entries = signal<any[]>([]);
    totalEntries = signal<number>(0);
    predicate = signal<string>('created_at');
    reverse = signal<boolean>(true);

    ngOnInit(): void {
        const token = this.router.url.split('/')[2];

        this.dataService.request('Client/checkToken', {
            token,
            domain: this.accessService.client.domain
        }).subscribe((response) => {
           if (response.tokenValid) {
               this.accessService.token = token;

               this.listEntries(this.paginConfig);
           }
        });
    }

    setOrder(order: string): void {
        this.predicate.set(order);
        this.reverse.set(!this.reverse());
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.dataService.request('Admin/list', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate(),
            reverse: this.reverse(),
        }).subscribe(response => {
            this.totalEntries.set(response.total);
            this.entries.set(response.rooms);
        });
    }
}
